import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["paperProps", "children"],
    _excluded2 = ["sx"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Children, cloneElement, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IconButton, Menu } from '@mui/material';
import { Icon } from '@elements/icon';
import { pxToRem } from '@themes';
import more from '@images/more.svg';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

/**
 * Action Button component.
 *
 * @author Mikhail Siutsou
 * @function ActionButton
 * @category components
 * @param {ActionButtonProps} props Action Button.
 * @return {FC} Action Button component.
 */
var ActionButton = function ActionButton(_ref) {
  var _ref$paperProps = _ref.paperProps,
      paperProps = _ref$paperProps === void 0 ? {} : _ref$paperProps,
      children = _ref.children,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  var ref = useRef(null);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var sx = paperProps.sx,
      otherPaperProps = _objectWithoutProperties(paperProps, _excluded2);

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;
  /**
   * handle toggle popover.
   *
   * @author Mikhail Siutsou
   * @return {void}
   */


  var handleToggle = function handleToggle() {
    setIsOpen(function (prev) {
      return !prev;
    });
  };

  var childrenArray = Children.toArray(children);
  var childrenWithToggle = childrenArray.map(function (i) {
    return /*#__PURE__*/cloneElement(i, {
      handleToggle: handleToggle
    });
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(IconButton, {
      ref: ref,
      onClick: handleToggle,
      color: "secondary",
      title: t('components.buttons.actions'),
      children: /*#__PURE__*/_jsx(Icon, {
        src: more,
        width: 24,
        height: 24
      })
    }), /*#__PURE__*/_jsx(Menu, _objectSpread(_objectSpread({}, otherProps), {}, {
      open: isOpen,
      anchorEl: ref.current,
      onClose: handleToggle,
      MenuListProps: {
        sx: {
          p: 0
        }
      },
      PaperProps: _objectSpread(_objectSpread({}, otherPaperProps), {}, {
        sx: _objectSpread({
          borderRadius: pxToRem(14),
          boxShadow: '0px 4px 16px rgba(110, 118, 143, 0.3)',
          minWidth: pxToRem(194),
          maxWidth: '100%',
          py: pxToRem(8),
          '& .MuiMenuItem-root': {
            padding: "".concat(pxToRem(16), " ").concat(pxToRem(12)),
            fontSize: pxToRem(14),
            lineHeight: pxToRem(20),
            borderRadius: 0.75
          }
        }, sx && sx)
      }),
      anchorOrigin: {
        vertical: 'top',
        horizontal: 'left'
      },
      transformOrigin: {
        vertical: 'top',
        horizontal: 'left'
      },
      children: childrenWithToggle
    }))]
  });
};

export { ActionButton };